import { Typography } from '@mui/material';
import { hexToRGBA } from 'lib/designSystem/BarChart';
import React from 'react';

import EnhacedBox from '../Box';

const StatCard = ({
  label,
  value,
  valueLabel,
  color,
  icon,
}: {
  label: string;
  value: number | string;
  valueLabel: string;
  color: string;
  icon: React.ReactNode;
}) => {
  return (
    <EnhacedBox
      small
      props={{ style: { width: '100%', height: '100%' } }}
      margin="0px"
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          width: '100%',
        }}
      >
        <div
          style={{
            width: 42,
            height: 42,
            borderRadius: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: hexToRGBA(color, 0.12),
            color,
            lineHeight: 0,
            flexShrink: 0,
          }}
        >
          {icon}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="caption"
            sx={{
              textTransform: 'uppercase',
              letterSpacing: 1,
              color: 'text.primary',
            }}
          >
            {label}
          </Typography>
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              gap: 8,
              marginTop: 4,
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                color: 'text.primary',
                lineHeight: 1,
              }}
            >
              {value}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                textTransform: 'uppercase',
                letterSpacing: 1,
                color: 'text.secondary',
              }}
            >
              {valueLabel}
            </Typography>
          </div>
        </div>
      </div>
    </EnhacedBox>
  );
};

export default StatCard;
